import React from 'react';
import { Box, Skeleton } from '@mui/material';
import type { PreviewCategory } from '../../utils/previewUtils';

export interface PreviewSkeletonProps {
  category: PreviewCategory;
  compact?: boolean;
}

export const PreviewSkeleton: React.FC<PreviewSkeletonProps> = ({ category, compact = false }) => {
  const h = compact ? 200 : 400;

  if (category === 'image') {
    return (
      <Skeleton
        variant="rectangular"
        width="80%"
        height={compact ? 180 : 360}
        sx={{ maxWidth: 600, borderRadius: 1 }}
      />
    );
  }

  if (category === 'pdf' || category === 'docx') {
    return (
      <Skeleton
        variant="rectangular"
        width={compact ? '95%' : '70%'}
        height={h}
        sx={{ maxWidth: 700, borderRadius: 1 }}
      />
    );
  }

  if (category === 'video') {
    return (
      <Skeleton
        variant="rectangular"
        width="90%"
        sx={{ maxWidth: 720, aspectRatio: '16/9', borderRadius: 1 }}
      />
    );
  }

  if (category === 'audio') {
    return (
      <Box sx={{ width: '80%', maxWidth: 480 }}>
        <Skeleton variant="rounded" height={56} />
      </Box>
    );
  }

  if (category === 'text') {
    return (
      <Box sx={{ width: '90%', maxWidth: 800, p: 2 }}>
        {Array.from({ length: compact ? 6 : 12 }).map((_, i) => (
          <Skeleton key={i} height={20} sx={{ mb: 1 }} width={`${85 - (i % 3) * 10}%`} />
        ))}
      </Box>
    );
  }

  return <Skeleton variant="circular" width={64} height={64} />;
};

export default PreviewSkeleton;
